<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>고객지원</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>칭찬합니다</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">{{ title }}</p>
            <ul class="row" style="gap: 80px">
                <li>
                    <span
                        style="
                            padding-right: 20px;
                            border-right: 1px solid gray;
                        "
                        >날짜</span
                    >
                    <span style="padding-left: 20px">{{ date }}</span>
                </li>
                <li>
                    <span
                        style="
                            padding-right: 20px;
                            border-right: 1px solid gray;
                        "
                        >조회수</span
                    >
                    <span style="padding-left: 20px">{{ viewCount }}</span>
                </li>
            </ul>

            <div style="width: 100%; height: 2px; background: black"></div>
        </div>

        <div id="question" class="screen-width">
            <p v-html="formattedDetailText" style="white-space: pre-wrap"></p>
        </div>

        <div 
            class="screen-width" 
            style="
                display: flex;
                justify-content: end;
                margin-bottom: 40px;
            "
        >
            <button
                style="
                    width: 120px;
                    height: 60px;
                    border-radius: 10px;
                    background: #474747;
                "
                @click="goBack"
            >
                <p style="color: white; font-weight: bold">목록</p>
            </button>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, onUpdated, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";

export default {
    name: "complain-answer-layout",
    props: ["id"],
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
    },
    setup(props) {
        const store = useStore();
        const router = useRouter();
        const title = ref("");
        const date = ref("");
        const detail = ref("");
        const viewCount = ref(0);
        onUpdated(() => {
            // alert("hi");
        });

        const formattedDetailText = computed(() => {
            return detail.value.replace(/\\n/g, "<br>");
        });
        
        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        const goBack = () => {
            router.back();
        };

        onMounted(() => {
            store.dispatch("getPC", props.id).then((res) => {
                title.value = res.title;
                date.value = formatKoreanDate(res.createdAt);
                detail.value = res.detail;
                viewCount.value = res.viewCount;
            });
        });

        return {
            detail,
            title,
            date,
            formattedDetailText,
            formatKoreanDate,
            goBack,
            viewCount
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#product-list {
    width: 85%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

ul {
    list-style-type: none;
    list-style: none;
}

#question {
    padding-bottom: 40px;
}
.profile-image {
    border-radius: 50%; /* 원형 모양을 만듭니다 */
    object-fit: fill; /* 이미지가 컨테이너를 꽉 채우도록 합니다 */
    width: 60px; /* 이미지의 너비를 설정합니다 */
    height: 60px; /* 이미지의 높이를 설정합니다 */
}
</style>
